import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Button from '../../../../../../src/components/common/button-view';
import TextBadge from '@dbk/ui-text-badge';
import ForgotPassword from './forgot-password';
import VascoOTP from './vasco-otp';
import ChangePassword from '../../../../../../src/screens/change-password/change-password';
import ChangePasswordEcedentials from '../../../../../../src/screens/change-password/change-password-eCredentials';
import { SuccessIcon } from '../../../../../../src/components/common/icons/index';
import { PALETTE, FORGOT_PASSWORD_FLOW_STEPS } from '../../../../../../src/constants';

class ForgotPasswordModalContent extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            emailId: undefined,
            userIdEmpty: undefined,
        };
    }

    componentDidUpdate(previousProps, previousState) {
        // if (previousProps.forgotPassword.initiateResetPwdResultValid !== this.props.forgotPassword.initiateResetPwdResultValid) {
        //     this.setState({ showActivePage: FORGOT_PASSWORD_FLOW_STEPS[1]})
        // }
    }

    getStepsContent = (stepIndex) => {
        const { app : { config: { isAirLockUpgrade }}} = this.props;
        switch (stepIndex) {
        case FORGOT_PASSWORD_FLOW_STEPS[0]:
          return <ForgotPassword />;
        case FORGOT_PASSWORD_FLOW_STEPS[1]:
          return <VascoOTP />;
        case FORGOT_PASSWORD_FLOW_STEPS[2]:
          if(isAirLockUpgrade){
            return <ChangePasswordEcedentials />
          }
          return <ChangePassword />
        case FORGOT_PASSWORD_FLOW_STEPS[3]:
            return this.getPwdSuccessMessage();
        default:
          return 'unknown step';
       }
    }

    getPwdSuccessMessage = () => {
        const { i18n: { messages } } = this.props;
        return(
            <View className="padding-right-25">
                <div tabIndex={0} className="pad-top-bottom-10 title-ff-display font-size-26">
                    {messages['app.forgotPassword.success.msg']}
                    <SuccessIcon className="margin-left-20" color={PALETTE.successIcon} height={24} width={24}/>
                </div>
                <div tabIndex={0} className="margin-top-30 font-size-18 title-ff-display">
                     {messages['app.auth.changePasswordSuccess']}
                 </div>
                 <div className="margin-top-10">
                     {messages['app.reset.forgotPassword.successMsg']}
                 </div>
                 <View className="text-center pad-top-70">
                    <Button fullWidth size='large'
                    onPress={this.props.navigateToLogin}  // calling parent function
                    >
                    {messages['app.auth.login']}
                    </Button>
                    </View>
            </View>
        )
    }

    render() {
        const { i18n: { messages }, forgotPassword: { showCurrentStep }} = this.props;

        return (
            <div className="forgot_password">
                <div className="section-padding section_one">
                    {/* <ForgotPassword /> */}
                    {this.getStepsContent(showCurrentStep)}
                </div>
                <div className="section-padding section_two">
                    <div className='numeric-title' tabIndex={0} aria-label={`Step1: ${messages['app.reset.forgotPassword.tempPwd']}`}>
                        <TextBadge value={1} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[0]} className="abc" />
                        <div className="pad-top-2 margin-left-10 font-color-black title-ff-display ">{messages['app.reset.forgotPassword.tempPwd']}</div>
                    </div>
                    <div className='numeric-title' tabIndex={0} aria-label={`Step2: ${messages['app.auth.vasco.add.device.otp.title']}`}>
                        <TextBadge value={2} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[1]} className="content__step1__badge__style" />
                        <div className="pad-top-2 margin-left-10 font-color-black title-ff-display ">{messages['app.auth.vasco.add.device.otp.title']}</div>
                    </div>
                    <div className='numeric-title' tabIndex={0}  aria-label={`Step3: ${messages['app.reset.forgotPassword.createPwd']}`}>
                        <TextBadge value={3} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[2]} className="content__step1__badge__style" />
                        <div className="pad-top-2 margin-left-10 font-color-black title-ff-display ">{messages['app.reset.forgotPassword.createPwd']}</div>
                    </div>
                    <div className='numeric-title' tabIndex={0} aria-label={`Step4: ${messages['app.auth.login']}`}>
                        <TextBadge value={4} size='medium' secondary={showCurrentStep === FORGOT_PASSWORD_FLOW_STEPS[3]} className="content__step1__badge__style" />
                        <div className="pad-top-2 margin-left-10 font-color-black title-ff-display ">{messages['app.auth.login']}</div>
                    </div>
                    <div className="font-color-black" tabIndex={0}>
                        {messages['app.reset.forgotPassword.contactRM']}
                    </div>
                </div>
            </div>
        );
    }
};

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        forgotPassword: {
            showCurrentStep: true,
        },
        app: {
            config: {
                isAirLockUpgrade: true
            }
        }
    },
},
)(ForgotPasswordModalContent);

